import { client } from "./client";
import interceptors from "./interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function cekMitraMLM(params) {
    return client.get("tunnel/api/pos/common/check_member_mlm", {
        params: params,
    });
}

function cekMitraID(params) {
    return client.get("tunnel/api/pos/common/check_member_id", {
        params: params,
    });
}

function dataAreaMLM(params) {
    return client.get("tunnel/api/pos/common/registration_area", {
        params: params,
    });
}

function mandatoryCheck(params) {
    return client.get("tunnel/api/pos/common/mandatory_check", {
        params: params,
    });
}

function getProvince() {
    return client.get('tunnel/api/public/general/province');
}

function getProvinceStockist() {
    return client.get('tunnel/api/public/general/provinceStockist');
}

function getCity(params) {
    return client.get('tunnel/api/public/general/city', {
        params: params
    });
}

function getSubdistrict(params) {
    return client.get('tunnel/api/public/general/subdistrict', {
        params: params
    });
}

function getOptionSerialName(params) {
    return client.get('tunnel/api/public/general/serial_name', {
        params: params
    });
}

export default {
    cekMitraMLM,
    cekMitraID,
    dataAreaMLM,
    mandatoryCheck,
    getProvince,
    getCity,
    getSubdistrict,
    getProvinceStockist,
    getOptionSerialName,
};
